import React, { useEffect } from "react";
import { connect } from "react-redux";
import get from "../../utils/get";
import UserListScreen from "../screens/UserListScreen";
import * as actions from "../actions/list";

const UserListContainer = (props) => {
  useEffect(() => {
    props.getUsers();
    // eslint-disable-next-line
  }, []);
  return <UserListScreen isLoading={props.isLoading} getUsers={props.getUsers} editUser={props.editUser} data={props.data} />;
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "users.list.isLoading"),
  data: get(state, "users.list.data"),
});

const mapActionsToProps = { ...actions };

export default connect(mapStateToProps, mapActionsToProps)(UserListContainer);
